"use client";

import { useEffect } from "react";

/**
 * Facebook's OAuth dialog appends an empty "#_=_" fragment to its redirect, and since none of the
 * intermediate redirects in the login flow (API callback -> BFF exchange -> here) specify a fragment
 * of their own, the browser carries it all the way to this page. Harmless (fragments never reach a
 * server, nothing reads it) but ugly in the address bar -- this just tidies it up after landing.
 */
export function StripOAuthFragment() {
  useEffect(() => {
    if (window.location.hash === "#_=_") {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }, []);

  return null;
}
